/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CheckMcpEndpointSlugAvailabilitySecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CheckMcpEndpointSlugAvailabilitySecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CheckMcpEndpointSlugAvailabilitySecurity = {
  option1?: CheckMcpEndpointSlugAvailabilitySecurityOption1 | undefined;
  option2?: CheckMcpEndpointSlugAvailabilitySecurityOption2 | undefined;
};

export type CheckMcpEndpointSlugAvailabilityRequest = {
  /**
   * The slug to check
   */
  slug: string;
  /**
   * Optional custom domain ID. Omit to check platform-domain slug availability.
   */
  customDomainId?: string | undefined;
  /**
   * Optional MCP server the slug is for. Addresses that server may claim, such as its own legacy alias, read as available.
   */
  mcpServerId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CheckMcpEndpointSlugAvailabilitySecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CheckMcpEndpointSlugAvailabilitySecurityOption1$outboundSchema:
  z.ZodMiniType<
    CheckMcpEndpointSlugAvailabilitySecurityOption1$Outbound,
    CheckMcpEndpointSlugAvailabilitySecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function checkMcpEndpointSlugAvailabilitySecurityOption1ToJSON(
  checkMcpEndpointSlugAvailabilitySecurityOption1:
    CheckMcpEndpointSlugAvailabilitySecurityOption1,
): string {
  return JSON.stringify(
    CheckMcpEndpointSlugAvailabilitySecurityOption1$outboundSchema.parse(
      checkMcpEndpointSlugAvailabilitySecurityOption1,
    ),
  );
}

/** @internal */
export type CheckMcpEndpointSlugAvailabilitySecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CheckMcpEndpointSlugAvailabilitySecurityOption2$outboundSchema:
  z.ZodMiniType<
    CheckMcpEndpointSlugAvailabilitySecurityOption2$Outbound,
    CheckMcpEndpointSlugAvailabilitySecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function checkMcpEndpointSlugAvailabilitySecurityOption2ToJSON(
  checkMcpEndpointSlugAvailabilitySecurityOption2:
    CheckMcpEndpointSlugAvailabilitySecurityOption2,
): string {
  return JSON.stringify(
    CheckMcpEndpointSlugAvailabilitySecurityOption2$outboundSchema.parse(
      checkMcpEndpointSlugAvailabilitySecurityOption2,
    ),
  );
}

/** @internal */
export type CheckMcpEndpointSlugAvailabilitySecurity$Outbound = {
  Option1?:
    | CheckMcpEndpointSlugAvailabilitySecurityOption1$Outbound
    | undefined;
  Option2?:
    | CheckMcpEndpointSlugAvailabilitySecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const CheckMcpEndpointSlugAvailabilitySecurity$outboundSchema:
  z.ZodMiniType<
    CheckMcpEndpointSlugAvailabilitySecurity$Outbound,
    CheckMcpEndpointSlugAvailabilitySecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        CheckMcpEndpointSlugAvailabilitySecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        CheckMcpEndpointSlugAvailabilitySecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function checkMcpEndpointSlugAvailabilitySecurityToJSON(
  checkMcpEndpointSlugAvailabilitySecurity:
    CheckMcpEndpointSlugAvailabilitySecurity,
): string {
  return JSON.stringify(
    CheckMcpEndpointSlugAvailabilitySecurity$outboundSchema.parse(
      checkMcpEndpointSlugAvailabilitySecurity,
    ),
  );
}

/** @internal */
export type CheckMcpEndpointSlugAvailabilityRequest$Outbound = {
  slug: string;
  custom_domain_id?: string | undefined;
  mcp_server_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CheckMcpEndpointSlugAvailabilityRequest$outboundSchema:
  z.ZodMiniType<
    CheckMcpEndpointSlugAvailabilityRequest$Outbound,
    CheckMcpEndpointSlugAvailabilityRequest
  > = z.pipe(
    z.object({
      slug: z.string(),
      customDomainId: z.optional(z.string()),
      mcpServerId: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        customDomainId: "custom_domain_id",
        mcpServerId: "mcp_server_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function checkMcpEndpointSlugAvailabilityRequestToJSON(
  checkMcpEndpointSlugAvailabilityRequest:
    CheckMcpEndpointSlugAvailabilityRequest,
): string {
  return JSON.stringify(
    CheckMcpEndpointSlugAvailabilityRequest$outboundSchema.parse(
      checkMcpEndpointSlugAvailabilityRequest,
    ),
  );
}
